import { ReactNode } from "react";
import { Stack, Typography, useTheme } from "@mui/material";
import { Badge, useResponsiveBreakpoints } from "@foodpilot/foods";

export type TextTitleProps = {
    title: string;
    badge: ReactNode;
};
export const PageHeader = (props: TextTitleProps) => {
    const theme = useTheme();
    const { title, badge } = props;

    const { isMobile } = useResponsiveBreakpoints();

    return (
        <Stack direction="row" alignItems="center" gap={theme.spacing(2)} minWidth={0}>
            {typeof badge === "number" ?
                <Badge size={isMobile ? "small" : "big"}>{badge}</Badge>
            :   <Stack width="40px" alignItems="center" color={theme.custom.grey[2800]}>
                    <Stack sx={{ transform: "scale(250%)" }}>{badge}</Stack>
                </Stack>
            }
            <Typography variant={"h1"}>{title}</Typography>
        </Stack>
    );
};
